import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Purchase, PurchaseDetail } from "../../models/purchase.model";

import { PurchaseService } from "../../services/purchase.service";

@Component({
  selector: "ngx-dialog-purchase-detail",
  templateUrl: "dialog-purchase-detail.component.html",
  styleUrls: ["dialog-purchase-detail.component.scss"],
})
export class DialogPurchaseDetailComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() purchaseDetail?: PurchaseDetail;

  loading = false;
  submitted = false;
  strSearch = "";
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    protected ref: NbDialogRef<DialogPurchaseDetailComponent>,
    private purchaseService: PurchaseService,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    this.ref.close(this.purchaseDetail);
  }

  productQuantityIncrement(value) {
    this.purchaseDetail.quantity += value;
    this.summaryPurchaseDetail();
  }

  summaryPurchaseDetail() {
    this.purchaseDetail.price = this.purchaseDetail.price
      ? parseFloat(this.purchaseDetail.price.toString())
      : 0;

    this.purchaseDetail.netAmount =
      this.purchaseDetail.quantity * this.purchaseDetail.price;

    if (this.purchaseDetail.discountPercent != 0) {
      // this.purchaseDetail.discountAmount = Math.round(
      //   (this.purchaseDetail.netAmount * this.purchaseDetail.discountPercent) /
      //     100
      // );
      let numb =
        (this.purchaseDetail.netAmount * this.purchaseDetail.discountPercent) /
        100;
      this.purchaseDetail.discountAmount =
        Math.round((numb + Number.EPSILON) * 100) / 100;
      this.purchaseDetail.discountAmount = Math.round(
        this.purchaseDetail.discountAmount,
      );
    }

    this.purchaseDetail.amount =
      this.purchaseDetail.netAmount - this.purchaseDetail.discountAmount;
  }

  inputDiscountAmount = false;
  bkDiscountAmount = 0;
  openInputDiscountAmount() {
    this.inputDiscountAmount = true;
    this.bkDiscountAmount = this.purchaseDetail.discountAmount;
  }
  closeInputDiscountAmount() {
    this.inputDiscountAmount = false;
    if (this.purchaseDetail.discountAmount !== this.bkDiscountAmount) {
      this.purchaseDetail.discountPercent = 0;
    }
    this.summaryPurchaseDetail();
  }
}
